import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ConfirmationDetailsTable from '../components/ConfirmationDetailsTable'
import paymentConfirmImage from '../assets/images/payment_confirmed.gif'
import cloudImage from '../assets/images/clouds_image.png'
import ConfirmationSubTotal from '../components/ConfirmationSubTotal'
import ConfirmationConvenienceFee from '../components/ConfirmationConvenienceFee'
import ConfirmationPaymentTotal from '../components/ConfirmationPaymentTotal'
import Table from 'react-bootstrap/Table'
import HeaderConfirmation from '../components/HeaderConfirmation'
import ConfirmationInfo from '../components/ConfirmationInfo'
import './ConfirmationPage.css';
import DialogModal from '../components/modals/DialogModal'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

function ConfirmationPage(props) {
  const location = useLocation()
  const serverData = location.state.serverMessage
  // console.log('data on confirmation ' + JSON.stringify(serverData))

  // restricting back button after confirmation  
  const navigate = useNavigate();
  // The popstate event is fired each time when the current history entry changes.
  window.addEventListener('popstate', function(event) {
      // redirecting to search page when browser back button clicked
      navigate("/");
      window.history.pushState(null, null, window.location.pathname);
  }, false);

 useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
    // redirecting to search page after 15 seconds
    /*setTimeout(function() {
      navigate("/");
      window.history.pushState(null, null, window.location.pathname);
    }, 15000); // 15 seconds in milliseconds (1000ms = 1s)
    */
  }, [])

  const printRef = useRef(); // Reference for capturing the area
  const [modalShow, setModalShow] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalMsg, setModalMsg] = useState('');

// Function to generate PDF
  const downloadReceipt = () => {

    setModalShow(true);
    setMessageType('loading');
    setModalTitle('Download Receipt')

    const input = printRef.current;
    
    html2canvas(input, {
      //scale: 3,
      scale: 1.5, // or even 1 for text-heavy receipts ; file size also depends here 
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.6); // image quality 0–1 ; file size also depends here
      // choose jpeg over png for file size constraints
      const pdf = new jsPDF("p", "mm", "a4", true); // true enables compression ; file size also depends here
    
      // Get page width and height
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
    
      // Scale image height maintaining aspect ratio
      const imgWidth = pdfWidth - 20; // leave some padding
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
      // Add image and save
      pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
      pdf.save("Payment_Receipt.pdf");
    })
    .catch((error) => {
      console.error('html2canvas failed:', error);
    })
    .finally(() => {;
      setModalShow(false);  
    });

  };

  const handleModalClose = () => { 
    setModalShow(false);  
  }

  const moment = require('moment');
  let paymentDateTime = moment(serverData.paymentDate).format("MM/DD/YYYY HH:mm A");

  return (
    <>
    <DialogModal modalShow={modalShow} modalTitle={modalTitle} messageType={messageType} modalMsg={modalMsg} handleModalClose={handleModalClose} />
 
    <div className='container'>
      {/* <HeaderOrder /> */}
      <div className='row'>
        <div className='col-md-12 col-12 mt-4'>
          <div className='text-end'>
            <button className='btn btn-warning' onClick={downloadReceipt}>
              <i className='fa fa-download'></i> Download Payment Receipt
            </button>
          </div>
        </div>
      </div>
      
      <div className='row my-4' ref={printRef}>
        <div className='col-md-6 offset-md-3 col-12' id="print-bol-area">
        <div className="card mb-4">
                <div className="card-header">
      <div className='row'>
                  <div className='col-md-12 col-8 pt-2'>
                  <h5 className='text-center'>PAYMENT DETAILS </h5>
                  </div>
                {/* <span class="small ms-1">Please enter your order number to display order details</span> */}
                </div>
                </div>

                <div className="card-body ">
                
      <div className='container'>
        <div className='row--welcome'>
          <HeaderConfirmation />
          <h3 className='text-center text--confirm'>
            Dear {serverData.customer.customerContactFirstName}{' '}
            {serverData.customer.customerContactLastName},
          </h3>
          <div className='text-center '>
            Thank you for your payment!
            <div className='mt-1'>
              You will be receiving an email confirmation with your receipt.
            </div>
            <div className='mt-1'>
              <b>Transaction ID</b> : <span className='fw-bold text-success' style={{'fontSize':'18px'}}>{serverData.paymentResponse.transactionId}</span>
              </div>
              <div className='mt-1'>
              <b>Payment Date & Time</b> : <span className='fw-bold text-primary' style={{'fontSize':'16px'}}>{paymentDateTime}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='container text-center image--confirm'>
        <img src={paymentConfirmImage} width='150' />
      </div>
      <div className='container text-center even-columns'>
        <ConfirmationInfo 
        confirmationData={serverData} />
      </div>

      <div className='container text-center even-columns'>
        <div className='col'>
          <Table responsive striped hover>
            <thead className='thead--confirmpay'>
              <tr>
                <th width="60%" className='thead--confirm-desc'>Description</th>
                <th width="25%" className='thead--confirm-amount text-center'>Amount</th>
                <th width="15%"></th>
              </tr>
            </thead>
            <ConfirmationDetailsTable confirmationData={serverData} />
            <tfoot className='tfoot--fees'>
              <ConfirmationSubTotal confirmationData={serverData} />
              <ConfirmationConvenienceFee confirmationData={serverData} />

              <ConfirmationPaymentTotal confirmationData={serverData} />
            </tfoot>
          </Table>
        </div>
      </div>

      <div className='container text-center image--confirm'>
        {/* <p className='text--questions'>Questions?</p> */}
        <p className='text--contact p-0 mb-2'>For further assistance, please contact us at {serverData?.cfsLocationPhoneNumber}.</p>
      </div>

      <div className='container text-center image--cloud even-columns'>
        <div>
          <img src={cloudImage} width='100%' />
        </div>
      </div>
      <div className='container text-center image--cloud even-columns'>
        <div className='text--stgusa'>
          <a className='text--stgusa' href='https://www.stgusa.com'>
            www.stgusa.com
          </a>
        </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      
    </>
  )
}

export default ConfirmationPage
